import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
} from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { LoggerService } from '../feature/services/logger.service';

export function errorInterceptor(
  request: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> {
  const messageService = inject(MessageService);
  const logger = inject(LoggerService);

  return next(request).pipe(
    catchError((error: HttpErrorResponse) => {
      if (error.error instanceof ArrayBuffer) {
        const errorText = new TextDecoder().decode(error.error);
        const errorJson = JSON.parse(errorText);
        logger.log(errorJson);
        return throwError(() => errorJson);
      } else {
        logger.log(error);
      }

      // TODO: remove this. refactor error interceptor to return whole error after logging, and catch this actual error in the service
      if (request.url.includes('prijedlozi') && request.method === 'GET') {
        messageService.add({
          severity: 'error',
          summary: 'Greška',
          detail: `Došlo je do pogreške prilikom komunikacije sa e-ovrhe API.
                  ${error.error.message}
                  Kod greške: ${error.status}`,
          life: 10000,
        });
      }

      return throwError(() => error);
    }),
  );
}
